import styled from "styled-components";
import { ExternalLink } from "../../links/ExternalLink";
import { colors } from "../../../styles/variables";

export const StyledForgotPasswordForm = styled.div`
  display: flex;
  flex-direction: column;

  button:last-child {
    margin-top: 15px;
  }
`;

export const StyledTitle = styled.div`
  margin-bottom: 10px;
  align-self: center;
`;

export const StyledText = styled.p`
  text-align: center;
  font-family: inherit;
  color: ${colors.gray900};
`;

export const StyledForm = styled.form`
  width: 100%;
`;

export const StyledExternalLink = styled(ExternalLink)`
  color: ${({ theme }) => theme.color.primary};
`;

export const StyledError = styled.span`
  display: block;
  font-size: 14px;
  line-height: 1.3;
  text-align: center;
  margin-top: -5px;
  margin-bottom: 10px;
  color: ${({ theme }) => theme.color.error};
`;
